<div class="container-align">
  <h3 class="title">Desculpe, algo deu errado</h3>
  <ids-icon class="close-icon" size="L">fechar</ids-icon>

  <span class="lighter-font">Ocorreu um erro ao acessar essa aplicação, tente novamente</span>
  <span>Se este erro persistir contate a equipe de câmbio <span *ngIf="errorCode">e informe o código de erro</span>
    <span *ngIf="errorCode"> {{ errorCode }}</span>
  </span>
</div>
